import { CdrBanner, CdrButton, CdrContainer, IconCheckFill, IconWarningFill } from "@rei/cedar";
import GenericPrice from "../GenericPrice/GenericPrice.mjs";
import _sfc_main$1 from "../MembershipBillboard/MembershipBillboard.mjs";
/* empty css                                           */
import GenericPreorderBanner from "../GenericPreorderBanner/GenericPreorderBanner.mjs";
import IconFeathers from "../Icons/IconFeathers/IconFeathers.mjs";
import RrRecs from "../RrRecs/RrRecs.mjs";
import { CdrBreakpointLg, CdrBreakpointSm, CdrBreakpointMd } from "@rei/cdr-tokens";
import { resolveComponent, openBlock, createBlock, normalizeClass, withCtx, createElementVNode, createVNode, createSlots, resolveDynamicComponent, toDisplayString, createTextVNode, createElementBlock, createCommentVNode, withModifiers, Fragment, mergeProps } from "vue";
/* empty css                        */
import _export_sfc from "../../../_virtual/_plugin-vue_export-helper.mjs";
const _sfc_main = {
  name: "AddToCartInterstitial",
  components: {
    CdrBanner,
    CdrButton,
    CdrContainer,
    GenericPrice,
    GenericPreorderBanner,
    IconCheckFill,
    IconFeathers,
    IconWarningFill,
    MembershipBillboard: _sfc_main$1,
    RrRecs
  },
  props: {
    bonusCardAmount: {
      type: Number,
      default: null
    },
    bonusCardCopy: {
      type: String,
      default: ""
    },
    brandName: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
    },
    colorLabel: {
      type: String,
      default: ""
    },
    hasBonusCard: {
      type: Boolean,
      default: false
    },
    imageSrc: {
      type: String,
      default: "/media/00000000-0000-0000-0000-000000000000"
    },
    includeMembership: {
      type: Boolean,
      required: true
    },
    isJustForMembersCopy: {
      type: String,
      default: ""
    },
    isPreorder: {
      type: Boolean,
      required: true
    },
    membershipBillboardProps: {
      type: Object,
      default: null
    },
    membershipCost: {
      type: String,
      required: true
    },
    price: {
      type: Object,
      required: true
    },
    productName: {
      type: String,
      required: true
    },
    quantity: {
      type: Number,
      required: true
    },
    recsPlacements: {
      type: Object,
      default: null
    },
    showColor: {
      type: Boolean,
      required: true
    },
    showSize: {
      type: Boolean,
      required: true
    },
    size: {
      type: String,
      default: ""
    },
    sizeLabel: {
      type: String,
      default: ""
    },
    subtotal: {
      type: Number,
      default: null
    },
    totalQuantity: {
      type: Number,
      default: null
    },
    recsComponent: {
      type: Object,
      required: true
    },
    showJFERepetitiveMessaging: {
      type: Boolean,
      default: false
    },
    overRequestMessage: {
      type: Object,
      default: null
    },
    showXlBreakpoint: {
      type: Boolean,
      default: false
    }
  },
  emits: ["acquisitionDetailsClick", "addMembershipToCart", "interstitialContinueShopping", "metricsClick", "preorderBannerClick", "recsClick", "retentionDetailsClick", "modalOpen"],
  data() {
    return {
      elToReturnFocus: null,
      maxRecsTiles: 5,
      maxAlternateRecsTiles: 3,
      hidePMBEl: null,
      rrRecsVisible: false,
      resizeObserver: null
    };
  },
  computed: {
    computedSubtotal() {
      var _a;
      return (_a = this.subtotal) == null ? void 0 : _a.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    computedTotalQuantity() {
      const quantity = this.totalQuantity;
      return `(${quantity} item${quantity > 1 ? "s" : ""})`;
    },
    bonusCardMessage() {
      if (this.bonusCardAmount && this.bonusCardCopy) {
        return `$${this.bonusCardAmount} ${this.bonusCardCopy || "bonus card included with order"}`;
      }
      return "Bonus card included with order";
    },
    containerClasses() {
      return {
        "atc-interstitial": true,
        "atc-interstitial--jfe": this.membershipBillboardProps.showAnyBillboard,
        "atc-interstitial--xl": this.showXlBreakpoint,
        "atc-interstitial--jfe--xl": this.membershipBillboardProps.showAnyBillboard && this.showXlBreakpoint
      };
    },
    headingText() {
      var _a;
      return ((_a = this.overRequestMessage) == null ? void 0 : _a.available) ? `${this.overRequestMessage.available} added to cart` : "Added to Cart";
    },
    h1Icon() {
      return this.hasReducedQuantity ? IconWarningFill : IconCheckFill;
    },
    hasReducedQuantity() {
      var _a, _b;
      return !!((_a = this.overRequestMessage) == null ? void 0 : _a.requested) && !!((_b = this.overRequestMessage) == null ? void 0 : _b.available);
    }
  },
  beforeMount() {
    this.elToReturnFocus = window.document.activeElement;
  },
  mounted() {
    this.$refs.root.$el.focus();
    this.maxAlternateRecsTiles = this.getMaxAltTiles();
    this.maxRecsTiles = this.getMaxRecsTiles();
    this.hidePMBEl = document.createElement("style");
    this.hidePMBEl.innerHTML = "#promo-message-banner { display: none;}";
    document.head.appendChild(this.hidePMBEl);
    this.resizeObserver = new ResizeObserver(this.resizeObserverCB);
    this.resizeObserver.observe(this.$refs.root.$el);
  },
  unmounted() {
    this.elToReturnFocus.focus();
    if (this.hidePMBEl) document.head.removeChild(this.hidePMBEl);
    if (this.resizeObserver) this.resizeObserver.disconnect();
  },
  methods: {
    continueShopping() {
      this.$emit("interstitialContinueShopping");
      this.$emit("metricsClick", {
        linkName: "modal_cart_continue_shopping"
      });
    },
    returnToProductDetails() {
      this.$emit("interstitialContinueShopping");
      this.$emit("metricsClick", {
        linkName: "modal_cart_return to product details"
      });
    },
    checkoutMetrics(event) {
      this.$emit("metricsClick", {
        linkName: "modal_cart_checkout",
        link: "/ShoppingCart",
        event
      });
    },
    handleRrRecs() {
      if (!this.rrRecsVisible) {
        this.rrRecsVisible = true;
        this.$emit("metricsClick", {
          linkName: "atc_algonomy_view"
        });
      }
    },
    resizeObserverCB() {
      this.maxAlternateRecsTiles = this.getMaxAltTiles();
      this.maxRecsTiles = this.getMaxRecsTiles();
    },
    getMaxAltTiles() {
      let tiles = 2;
      if (window.matchMedia(`(min-width: ${CdrBreakpointLg}px)`).matches) tiles = 3;
      return tiles;
    },
    getMaxRecsTiles() {
      let tiles = 5;
      if (window.matchMedia(`(max-width: ${CdrBreakpointSm - 1}px)`).matches) tiles = 2;
      if (window.matchMedia(`(min-width: ${CdrBreakpointSm}px) and (max-width: ${CdrBreakpointMd - 1}px)`).matches) tiles = 3;
      if (window.matchMedia(`(min-width: ${CdrBreakpointMd}px) and (max-width: ${CdrBreakpointLg - 1}px)`).matches) tiles = 4;
      return tiles;
    }
  }
};
const _hoisted_1 = {
  class: "atc-interstitial__top"
};
const _hoisted_2 = {
  class: "atc-interstitial__title-wrapper"
};
const _hoisted_3 = {
  key: 0,
  class: "atc-interstitial__just-for-members",
  "data-ui": "atc-member-thank-you"
};
const _hoisted_4 = {
  class: "atc-interstitial__content"
};
const _hoisted_5 = {
  class: "atc-interstitial__product-details",
  "aria-label": "Product details - item added to cart"
};
const _hoisted_6 = {
  class: "atc-interstitial__image-wrapper"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "atc-interstitial__description"
};
const _hoisted_9 = {
  id: "atc-modal-product-brand"
};
const _hoisted_10 = {
  id: "atc-modal-product-title",
  class: "atc-interstitial__description--product-title"
};
const _hoisted_11 = {
  class: "atc-interstitial__description--price"
};
const _hoisted_12 = {
  key: 0,
  id: "atc-modal-product-size"
};
const _hoisted_13 = {
  key: 1,
  id: "atc-modal-product-color"
};
const _hoisted_14 = {
  key: 2,
  id: "atc-modal-product-qty"
};
const _hoisted_15 = {
  class: "atc-interstitial__quantity-reduced"
};
const _hoisted_16 = {
  key: 3,
  id: "atc-modal-product-qty"
};
const _hoisted_17 = {
  key: 1,
  class: "atc-interstitial__membership"
};
const _hoisted_18 = {
  class: "atc-interstitial__membership-amount"
};
const _hoisted_19 = {
  key: 2,
  class: "atc-interstitial__bonus-card"
};
const _hoisted_20 = {
  id: "atc-modal-cart-subtotal",
  class: "atc-interstitial__total"
};
const _hoisted_21 = {
  id: "atc-modal-cart-count",
  class: "atc-interstitial__item-count"
};
const _hoisted_22 = {
  class: "atc-interstitial__buttons"
};
const _hoisted_23 = {
  key: 0,
  "aria-labelledby": "atc-recommendations-title-alt",
  class: "atc-interstitial__recs-wrapper"
};
const _hoisted_24 = {
  key: 1,
  class: "atc-interstitial__divider"
};
const _hoisted_25 = {
  "aria-labelledby": "atc-recommendations-title",
  class: "atc-interstitial__recs-wrapper"
};
const _hoisted_26 = {
  "aria-labelledby": "atc-recommendations-title-secondary",
  class: "atc-interstitial__recs-wrapper"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_cdr_banner = resolveComponent("cdr-banner");
  const _component_icon_feathers = resolveComponent("icon-feathers");
  const _component_generic_preorder_banner = resolveComponent("generic-preorder-banner");
  const _component_generic_price = resolveComponent("generic-price");
  const _component_icon_warning_fill = resolveComponent("icon-warning-fill");
  const _component_cdr_button = resolveComponent("cdr-button");
  const _component_membership_billboard = resolveComponent("membership-billboard");
  const _component_rr_recs = resolveComponent("rr-recs");
  const _component_cdr_container = resolveComponent("cdr-container");
  return openBlock(), createBlock(_component_cdr_container, {
    ref: "root",
    class: normalizeClass($options.containerClasses),
    "data-ui": "atc-interstitial",
    tabindex: "-1"
  }, {
    default: withCtx(() => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C;
      return [createElementVNode("div", _hoisted_1, [createElementVNode("div", {
        class: normalizeClass(["atc-interstitial__summary", $props.showXlBreakpoint && "atc-interstitial__summary--xl"])
      }, [createElementVNode("div", _hoisted_2, [createVNode(_component_cdr_banner, {
        type: $options.hasReducedQuantity ? "warning" : "success",
        class: "atc-interstitial__title",
        "data-ui": "added-to-cart-message"
      }, createSlots({
        "icon-left": withCtx(() => [(openBlock(), createBlock(resolveDynamicComponent($options.h1Icon)))]),
        default: withCtx(() => [createElementVNode("h1", null, toDisplayString($options.headingText), 1)]),
        _: 2
      }, [$options.hasReducedQuantity ? {
        name: "message-body",
        fn: withCtx(() => [createTextVNode(" Of the " + toDisplayString($props.overRequestMessage.requested) + " you requested, " + toDisplayString($props.overRequestMessage.available) + " are in stock. ", 1), _cache[11] || (_cache[11] = createElementVNode("br", null, null, -1)), createTextVNode(" We've added " + toDisplayString($props.overRequestMessage.available) + " to your cart. ", 1)]),
        key: "0"
      } : void 0]), 1032, ["type"])]), $props.isJustForMembersCopy ? (openBlock(), createElementBlock("div", _hoisted_3, [createVNode(_component_icon_feathers, {
        class: "atc-interstitial__feathers"
      }), createElementVNode("span", null, toDisplayString($props.isJustForMembersCopy), 1)])) : createCommentVNode("", true), createElementVNode("div", _hoisted_4, [createElementVNode("section", _hoisted_5, [$props.isPreorder ? (openBlock(), createBlock(_component_generic_preorder_banner, {
        key: 0,
        class: "atc-interstitial__preorder",
        onPreorderBannerClick: _cache[0] || (_cache[0] = () => _ctx.$emit("preorderBannerClick"))
      })) : createCommentVNode("", true), createElementVNode("button", {
        id: "atc-modal-product-detail-button",
        class: "atc-interstitial__img-and-summary",
        onClick: _cache[1] || (_cache[1] = withModifiers((...args) => $options.returnToProductDetails && $options.returnToProductDetails(...args), ["stop", "prevent"]))
      }, [createElementVNode("div", _hoisted_6, [createElementVNode("img", {
        id: "atc-modal-product-img",
        class: normalizeClass(["atc-interstitial__image", $props.membershipBillboardProps.showAnyBillboard && $props.showXlBreakpoint && "atc-interstitial__image--jfe-xl"]),
        src: $props.imageSrc,
        alt: ""
      }, null, 10, _hoisted_7)]), createElementVNode("div", _hoisted_8, [createElementVNode("div", _hoisted_9, toDisplayString($props.brandName), 1), createElementVNode("div", _hoisted_10, toDisplayString($props.productName), 1), createElementVNode("div", _hoisted_11, [createVNode(_component_generic_price, {
        id: "atc-modal-product-price",
        price: $props.price
      }, null, 8, ["price"])]), $props.showSize ? (openBlock(), createElementBlock("div", _hoisted_12, toDisplayString($props.sizeLabel) + ": " + toDisplayString($props.size), 1)) : createCommentVNode("", true), $props.showColor ? (openBlock(), createElementBlock("div", _hoisted_13, toDisplayString($props.colorLabel) + ": " + toDisplayString($props.color), 1)) : createCommentVNode("", true), $options.hasReducedQuantity ? (openBlock(), createElementBlock("div", _hoisted_14, [createTextVNode(" Quantity: " + toDisplayString($props.overRequestMessage.available) + " ", 1), createElementVNode("span", _hoisted_15, [createTextVNode(toDisplayString($props.overRequestMessage.requested) + " ", 1), createVNode(_component_icon_warning_fill, {
        size: "small"
      })])])) : (openBlock(), createElementBlock("div", _hoisted_16, " Quantity: " + toDisplayString($props.quantity), 1))])]), $props.includeMembership ? (openBlock(), createElementBlock("div", _hoisted_17, [_cache[12] || (_cache[12] = createTextVNode(" REI Co-op Membership: ")), createElementVNode("span", _hoisted_18, "$" + toDisplayString($props.membershipCost), 1)])) : createCommentVNode("", true), $props.hasBonusCard ? (openBlock(), createElementBlock("div", _hoisted_19, toDisplayString($options.bonusCardMessage), 1)) : createCommentVNode("", true), createElementVNode("div", _hoisted_20, [createTextVNode(" Cart Subtotal: $" + toDisplayString($options.computedSubtotal) + " ", 1), createElementVNode("span", _hoisted_21, toDisplayString($options.computedTotalQuantity), 1)]), createElementVNode("div", _hoisted_22, [createVNode(_component_cdr_button, {
        id: "atc-modal-btn-checkout",
        class: "atc-interstitial__button-checkout",
        tag: "a",
        "full-width": true,
        href: "'/ShoppingCart",
        onClick: _cache[2] || (_cache[2] = ($event) => $options.checkoutMetrics($event))
      }, {
        default: withCtx(() => _cache[13] || (_cache[13] = [createTextVNode(" Cart & Checkout ")])),
        _: 1,
        __: [13]
      }), createVNode(_component_cdr_button, {
        id: "atc-modal-btn-continue-shopping",
        modifier: "secondary",
        "full-width": true,
        onClick: $options.continueShopping
      }, {
        default: withCtx(() => _cache[14] || (_cache[14] = [createTextVNode(" Continue shopping ")])),
        _: 1,
        __: [14]
      }, 8, ["onClick"])])])])], 2), _cache[16] || (_cache[16] = createElementVNode("div", {
        class: "atc-interstitial__divider"
      }, null, -1)), _cache[17] || (_cache[17] = createElementVNode("div", {
        class: "atc-interstitial__divider--vertical"
      }, null, -1)), $props.membershipBillboardProps.showAnyBillboard ? (openBlock(), createElementBlock(Fragment, {
        key: 0
      }, [createVNode(_component_membership_billboard, mergeProps($props.membershipBillboardProps, {
        onAcquisitionDetailsClick: _cache[3] || (_cache[3] = (data) => _ctx.$emit("modalOpen", data)),
        onAddMembershipToCart: _cache[4] || (_cache[4] = (data) => _ctx.$emit("addMembershipToCart", data)),
        onMetricsClick: _cache[5] || (_cache[5] = (data) => _ctx.$emit("metricsClick", data)),
        onRetentionDetailsClick: _cache[6] || (_cache[6] = (data) => _ctx.$emit("modalOpen", data))
      }), null, 16), _cache[15] || (_cache[15] = createElementVNode("div", {
        class: "atc-interstitial__divider"
      }, null, -1))], 64)) : (openBlock(), createElementBlock("aside", {
        key: 1,
        "aria-labelledby": "atc-recommendations-title-alt",
        class: normalizeClass(["atc-interstitial__recs-wrapper--top", $props.showXlBreakpoint && "atc-interstitial__recs-wrapper--top-xl"])
      }, [createVNode(_component_rr_recs, {
        ref: "primaryRecs",
        "dynamic-sizing": false,
        "header-id": "atc-recommendations-title-alt",
        "recs-id": "atc-recs-alt",
        "recs-component": $props.recsComponent,
        "show-loading-recs": !((_b = (_a = $props.recsPlacements) == null ? void 0 : _a.primary) == null ? void 0 : _b.items),
        "max-tiles": $data.maxAlternateRecsTiles,
        message: (_d = (_c = $props.recsPlacements) == null ? void 0 : _c.primary) == null ? void 0 : _d.message,
        recs: $props.recsPlacements.primary,
        onRecsClick: _cache[7] || (_cache[7] = (data) => _ctx.$emit("recsClick", data)),
        onRecsVisible: $options.handleRrRecs
      }, null, 8, ["recs-component", "show-loading-recs", "max-tiles", "message", "recs", "onRecsVisible"])], 2))]), $props.membershipBillboardProps.showAnyBillboard ? (openBlock(), createElementBlock("aside", _hoisted_23, [createVNode(_component_rr_recs, {
        ref: "primaryRecs",
        "dynamic-sizing": false,
        "recs-id": "atc-recs-alt",
        "recs-component": $props.recsComponent,
        "show-loading-recs": !((_f = (_e = $props.recsPlacements) == null ? void 0 : _e.primary) == null ? void 0 : _f.items),
        "header-id": "atc-recommendations-title-alt",
        "max-tiles": $data.maxRecsTiles,
        message: (_h = (_g = $props.recsPlacements) == null ? void 0 : _g.primary) == null ? void 0 : _h.message,
        items: (_j = (_i = $props.recsPlacements) == null ? void 0 : _i.primary) == null ? void 0 : _j.items,
        "placement-name": (_l = (_k = $props.recsPlacements) == null ? void 0 : _k.primary) == null ? void 0 : _l.placementName,
        recs: $props.recsPlacements.primary,
        onRecsClick: _cache[8] || (_cache[8] = (data) => _ctx.$emit("recsClick", data))
      }, null, 8, ["recs-component", "show-loading-recs", "max-tiles", "message", "items", "placement-name", "recs"])])) : createCommentVNode("", true), ((_n = (_m = $props.recsPlacements) == null ? void 0 : _m.primary) == null ? void 0 : _n.items) && ((_p = (_o = $props.recsPlacements) == null ? void 0 : _o.secondary) == null ? void 0 : _p.items) ? (openBlock(), createElementBlock("div", _hoisted_24)) : createCommentVNode("", true), createElementVNode("aside", _hoisted_25, [createVNode(_component_rr_recs, {
        id: "atc-recs",
        ref: "secondaryRecs",
        "dynamic-sizing": false,
        "header-id": "atc-recommendations-title-primary",
        "show-loading-recs": !((_r = (_q = $props.recsPlacements) == null ? void 0 : _q.secondary) == null ? void 0 : _r.items),
        "max-tiles": $data.maxRecsTiles,
        message: (_t = (_s = $props.recsPlacements) == null ? void 0 : _s.secondary) == null ? void 0 : _t.message,
        "recs-component": $props.recsComponent,
        "img-size": 120,
        recs: (_u = $props.recsPlacements) == null ? void 0 : _u.secondary,
        "placement-name": (_w = (_v = $props.recsPlacements) == null ? void 0 : _v.secondary) == null ? void 0 : _w.placementName,
        strategy: (_y = (_x = $props.recsPlacements) == null ? void 0 : _x.secondary) == null ? void 0 : _y.strategy,
        onRecsClick: _cache[9] || (_cache[9] = (data) => _ctx.$emit("recsClick", data))
      }, null, 8, ["show-loading-recs", "max-tiles", "message", "recs-component", "recs", "placement-name", "strategy"])]), createElementVNode("aside", _hoisted_26, [createVNode(_component_rr_recs, {
        id: "atc-recs-secondary",
        ref: "tertiaryRecs",
        "dynamic-sizing": false,
        "header-id": "atc-recommendations-title-secondary",
        "show-loading-recs": !((_A = (_z = $props.recsPlacements) == null ? void 0 : _z.tertiary) == null ? void 0 : _A.items),
        "max-tiles": $data.maxRecsTiles,
        message: (_C = (_B = $props.recsPlacements) == null ? void 0 : _B.tertiary) == null ? void 0 : _C.message,
        recs: $props.recsPlacements.tertiary,
        "recs-component": $props.recsComponent,
        "img-size": 120,
        onRecsClick: _cache[10] || (_cache[10] = (data) => _ctx.$emit("recsClick", data))
      }, null, 8, ["show-loading-recs", "max-tiles", "message", "recs", "recs-component"])])];
    }),
    _: 1
  }, 8, ["class"]);
}
const AddToCartInterstitial = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-455703b8"]]);
export {
  AddToCartInterstitial as default
};
//# sourceMappingURL=AddToCartInterstitial.mjs.map
